import React, { useState, useEffect } from 'react';
import StoreDropdown from './StoreDropdown';
import ProductSelection from './ProductSelection';
import TransferItemsList from './TransferItemsList';

const DieuChuyen = () => {
    const [selectedStore, setSelectedStore] = useState('');
    const [transferItems, setTransferItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleAddItem = (product, quantity) => {
        const newItem = {
            maSP: product.MaSP,
            ten_SP: product.Ten_SP,
            dvt_SP: product.DVT_SP,
            maNLSP: product.MaNLSP,
            donGia: product.DonGia,
            soLuongDieuChuyen: parseFloat(quantity)
        };

        setTransferItems(prev => {
            const existingIndex = prev.findIndex(item => item.maSP === product.MaSP);
            if (existingIndex >= 0) {
                const updated = [...prev];
                updated[existingIndex] = newItem;
                return updated;
            }
            return [...prev, newItem];
        });
    };

    const handleRemoveItem = (maSP) => {
        setTransferItems(prev => prev.filter(item => item.maSP !== maSP));
    };

    const handleUpdateQuantity = (maSP, newQuantity) => {
        setTransferItems(prev => 
            prev.map(item => 
                item.maSP === maSP 
                    ? { ...item, soLuongDieuChuyen: newQuantity }
                    : item
            )
        );
    };

    const handleSubmit = async () => {
        if (!selectedStore || transferItems.length === 0) {
            alert('Vui lòng chọn cửa hàng và thêm sản phẩm cần điều chuyển');
            return;
        }

        setLoading(true);
        try {
            const tenUser = localStorage.getItem('TenUser');
            const idch_Chuyen = parseInt(localStorage.getItem('IDCH'));
            const ngayDieuChuyen = new Date().toISOString();

            const payload = {
                tenUser,
                ngayDieuChuyen,
                idch_Chuyen,
                idch_Nhan: parseInt(selectedStore),
                items: transferItems
            };

            const response = await fetch('https://doticom.vn:5000/api/DieuChuyenKho/batch', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                alert('Điều chuyển thành công!');
                setTransferItems([]);
                setSelectedStore('');
            } else {
                throw new Error('Lỗi khi điều chuyển');
            }
        } catch (error) {
            alert('Có lỗi xảy ra: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="content-section">
            {/* Header */}
            <div className="section-header" style={{ 
                textAlign: 'center',
                marginBottom: '32px',
                padding: '24px',
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderRadius: '16px',
                border: '1px solid #dee2e6'
            }}>
                <i className="fas fa-exchange-alt" style={{ 
                    fontSize: '48px', 
                    color: '#1976d2',
                    marginBottom: '16px'
                }}></i>
                <h2 style={{ margin: '0 0 8px 0', color: '#212529' }}>Điều Chuyển Kho</h2>
                <p style={{ margin: 0, fontSize: '16px' }}>
                    Quản lý điều chuyển sản phẩm giữa các cửa hàng
                </p>
            </div>
            
            {/* Store Selection */}
            <div className="card" style={{ marginBottom: '24px' }}>
                <div className="card-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <i className="fas fa-store" style={{ fontSize: '20px', color: '#1976d2' }}></i>
                        <div>
                            <h3 className="mb-0">Thông tin điều chuyển</h3>
                            <small className="text-muted">Chọn cửa hàng đích cho việc điều chuyển</small>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="form-group">
                        <label style={{ fontWeight: '600', marginBottom: '8px' }}>
                            <i className="fas fa-map-marker-alt me-2"></i>
                            Cửa hàng nhận hàng
                        </label>
                        <StoreDropdown 
                            selectedStore={selectedStore}
                            onStoreChange={setSelectedStore}
                        />
                    </div>
                </div>
            </div>

            {/* Product Selection */}
            <ProductSelection 
                onAddItem={handleAddItem} 
                transferItems={transferItems}
            />

            {/* Transfer Items List */}
            <TransferItemsList 
                items={transferItems}
                onRemoveItem={handleRemoveItem}
                onUpdateQuantity={handleUpdateQuantity}
            />

            {/* Submit Button */}
            <div className="card">
                <div className="card-body" style={{ 
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
                }}>
                    <button 
                        onClick={handleSubmit}
                        disabled={loading || !selectedStore || transferItems.length === 0}
                        className={`btn ${loading || !selectedStore || transferItems.length === 0 ? 'btn-secondary' : 'btn-primary'}`}
                        style={{ 
                            fontSize: '16px', 
                            padding: '16px 48px',
                            borderRadius: '12px',
                            fontWeight: '600',
                            minWidth: '200px'
                        }}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Đang xử lý...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-paper-plane me-2"></i>
                                Xác nhận điều chuyển
                            </>
                        )}
                    </button>
                    {(!selectedStore || transferItems.length === 0) && (
                        <div style={{ marginTop: '12px', fontSize: '14px', color: '#6c757d' }}>
                            {!selectedStore && !transferItems.length 
                                ? 'Vui lòng chọn cửa hàng và thêm sản phẩm'
                                : !selectedStore 
                                    ? 'Vui lòng chọn cửa hàng nhận hàng'
                                    : 'Vui lòng thêm ít nhất một sản phẩm'
                            }
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DieuChuyen;
